import { Text } from '@mantine/core';

export const NoDataToDisplay = () => {
  return <Text size="sm">No data to display for selected milestone</Text>;
};
